module.exports = __webpack_public_path__ + "catalog/items/up-arrow/upArrow.svg";